<template>
  <div>
    <PageAllow
      controller="Orders"
      :action="isNew ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <!-- id="fix-header" -->
      <!-- class="transparent-background-color py-4" -->
      <!-- :class="$vuetify.rtl ? 'fix-header-card-rtl ' : 'fix-header-card '" -->
      <v-sheet class="transparent-background-color py-4 mx-4">
        <v-expansion-panels v-model="panels" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{
                  $t(isNew ? "CRUD.newInfo" : "CRUD.info", [
                    $t("Order.ObjectName"),
                  ])
                }}
                <v-chip
                  v-if="order.cancel_flg || order.error_flg"
                  small
                  label
                  outlined
                  class="ms-4 mt-1"
                  color="danger"
                >
                  {{
                    order.cancel_flg
                      ? $t("CRUD.cancelled")
                      : $t("Order.redeliverError")
                  }}
                </v-chip>
                <v-chip
                  v-if="!savable"
                  small
                  label
                  class="ms-4 mt-1"
                  :color="order.status | orderStatusColor"
                  :text-color="order.status | orderStatusTextColor"
                  >{{ order.status | orderStatusText }}
                </v-chip>
                <v-chip
                  v-if="!savable"
                  small
                  label
                  class="ms-4 mt-1"
                  :color="bill.pay_flg | billPayFlgsColor"
                  :text-color="bill.pay_flg | billPayFlgsTextColor"
                  >{{ bill.pay_flg | billPayFlgsText }}
                </v-chip>
                <v-spacer />
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <v-btn
                    v-if="
                      accountSettings &&
                      accountSettings.push_platform == 1017 &&
                      order.status == 6
                    "
                    small
                    dark
                    color="action"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="UploadDialog = true"
                  >
                    <v-icon x-small class="pe-1">fa-file-image</v-icon>
                    {{ $t("Order.actions.importInvoice") }}
                  </v-btn>
                  <!-- 返回查看 -->
                  <v-btn
                    v-if="!isNew && savable && !preview"
                    small
                    dark
                    outlined
                    color="secondary"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="
                      mode = 'view';
                      loaded = false;
                    "
                  >
                    <v-icon x-small class="pe-1">fa-times</v-icon>
                    {{ $t("CRUD.backToView") }}
                  </v-btn>
                  <v-btn
                    v-if="preview"
                    small
                    dark
                    outlined
                    color="secondary"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="
                      order = JSON.parse(orderBeforPreview);
                      preview = false;
                    "
                  >
                    <v-icon x-small class="pe-1">fa-times</v-icon>
                    {{ $t("CRUD.backForModify") }}
                  </v-btn>
                  <v-btn
                    v-if="isNew && $permission.permissionAllow('Orders', 'add')"
                    small
                    :disabled="!shop || !shop.id"
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="preview ? doSubmit() : doPreview()"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("Order.actions.submitOrder") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      mode == 'confirm' &&
                      order.actions &&
                      order.actions.confirm &&
                      $permission.permissionAllow('Orders', 'confirm')
                    "
                    small
                    :dark="loaded || order.coupon_detail_id != null"
                    color="action"
                    class="px-2 me-2 mb-1"
                    @click.stop="preview ? doSubmit() : doPreview()"
                    :disabled="
                      !loaded &&
                      edit_details_mode == 0 &&
                      order.coupon_detail_id == null
                    "
                  >
                    <v-icon x-small class="pe-1">fa-location-arrow</v-icon>
                    {{ $t("Order.actions.confirmOrderSubmit") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      mode == 'edit' &&
                      order.actions &&
                      order.actions.shop_edit &&
                      $permission.permissionAllow('Orders', 'edit')
                    "
                    small
                    :dark="loaded || order.coupon_detail_id != null"
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="preview ? doSubmit() : doPreview()"
                    :disabled="
                      !loaded &&
                      edit_details_mode == 0 &&
                      order.coupon_detail_id == null
                    "
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("Order.actions.editOrderSubmit") }}
                  </v-btn>
                </v-sheet>
                <OrderActions
                  v-if="isView"
                  :order="order"
                  detail-mode
                  showEdit
                  @edit="mode = 'edit'"
                  showConfirm
                  @confirm="mode = 'confirm'"
                  showRedeliver
                  showApprove
                  showCancel
                  showPrint
                  :showCloudPrint="accountSettings && accountSettings.cloud_print_enable"
                />
              </v-card-title>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Order.Fields.order_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ order.order_code }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Order.Fields.origin_flg")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ order.origin_flg | orderOriginFlgsText }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" class="d-inline d-md-none">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Order.Fields.creater") }}{{ $t("Global.colon") }}
                    </span>
                    {{ order.creater_name }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Order.Fields.created_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ order.created | formatTime }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Order.Fields.expect_date")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      class="my-n2"
                      v-if="savable"
                      v-model="order.expect_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                      :disabled-before-today="isNew"
                    />
                    <span v-else>
                      {{ order.expect_date | formatTime }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Shop.Fields.shop_name", [$consts.shopName()])
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ this.accountUser ? this.accountUser.shop_name : "" }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4" class="d-none d-md-inline">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Order.Fields.creater") }}{{ $t("Global.colon") }}
                    </span>
                    <span v-if="savable">
                      {{ this.accountUser ? this.accountUser.shop_user_name : "" }}
                    </span>
                    <span v-else>
                      {{ order.creater_name }}
                    </span>
                  </v-card>
                </v-col>
<!--                <v-col cols="12" md="8" v-if="savable"></v-col>-->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Shop.Fields.shop_code", [$consts.shopName()])
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ this.accountUser ? this.accountUser.shop_code : "" }}
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{
                        order.order_extra && order.order_extra.express
                          ? $t("Order.Fields.receiver_address")
                          : $t("Order.Fields.shop_address", [
                              $consts.shopName(),
                            ])
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span v-if="order.order_extra && order.order_extra.express">
                      {{
                        $t("Order.Fields.receiver_address_format", [
                          order.order_extra.express.receiver_province,
                          order.order_extra.express.receiver_city,
                          order.order_extra.express.receiver_area,
                          order.order_extra.express.receiver_address,
                        ])
                      }}
                    </span>
                    <span v-else>
                      {{ (order.address && order.address.address) ? order.address.address : '' }}
                    </span>
                    <v-icon
                      v-if="!preview"
                      small
                      class="ps-2 action--text d-none"
                    >
                      fa-map-marked-alt
                    </v-icon>
                    <!-- 切换地址按钮 -->
                    <v-btn
                      v-if="(savable || isView) && order.status == 1"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="selectShopAddressDialog = true"
                    >
                      <v-icon x-small class="pe-1">fa-store</v-icon>
                      {{ $t("Order.address.resetAddress") }}
                    </v-btn>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Order.Fields.memo") }}{{ $t("Global.colon") }}
                    </span>
                    <v-text-field
                      v-if="savable"
                      v-model="order.memo"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    />
                    <span v-else>
                      {{ order.memo }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="d-none">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Order.Fields.campaigns") }}{{ $t("Global.colon") }}
                    </span>
                    TODO
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="d-none">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Order.Fields.attachments")
                      }}{{ $t("Global.colon") }}
                    </span>
                    TODO
                  </v-card>
                </v-col>
                <!-- 附件 -->
                <v-col cols="12" sm="12" md="12">
                  <v-card
                    class="pa-2 text-no-wrap d-flex overflow-auto"
                    outlined
                    tile
                  >
                    <span class="secondary--text">
                      {{ $t("Order.Fields.attachments")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <!-- 上传图片集 -->
                    <span class="ml-4">
                      <v-card
                        height="160"
                        width="240"
                        v-if="album && album.length > 0"
                      >
                        <v-carousel
                          hide-delimiters
                          cycle
                          height="160"
                          width="240"
                        >
                          <v-carousel-item
                            v-for="(item, i) in album"
                            :key="i"
                            :src="item"
                            @click.stop="$showFullscreenImages(album, i)"
                          >
                            <v-tooltip right v-if="isNew && item">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="secondary"
                                  class="pa-2 float-right"
                                  @click.stop="removeFromImages(i)"
                                >
                                  fa-times
                                </v-icon>
                              </template>
                              <span> {{ $t("Material.delImg") }}</span>
                            </v-tooltip>
                          </v-carousel-item>
                        </v-carousel>
                      </v-card>
                      <v-file-input
                        ref="imgs_file"
                        v-show="savable"
                        show-size
                        counter
                        small-chips
                        multiple
                        suffix
                        prepend-icon="fa-camera"
                        accept="image/png, image/jpeg"
                        persistent-hint
                        :placeholder="$t('Material.imgsPlaceholder')"
                        :hint="$t('Material.imgsHint')"
                        :rules="imgsRules"
                        v-model="imgs_file"
                      >
                      </v-file-input>
                    </span>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="!isNew">
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("Order.actions.activities") }}
                </v-tab>
                <v-tab
                  v-if="$permission.permissionAllow('Orders', 'relations')"
                  @click.stop="
                    tab = 1;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("Order.actions.relations") }}
                </v-tab>
                <v-tab
                  v-if="order.invoice_url"
                  @click.stop="
                    tab = 2;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("Order.actions.invoice") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="order_activities"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
                <v-tab-item
                  v-if="$permission.permissionAllow('Orders', 'relations')"
                >
                  <v-card flat>
                    <v-data-table
                      :headers="relationsHeaders"
                      :items="order_relations"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:header.actions="{ header }">
                        {{ header.text }}
                        <v-icon x-small>fa-sliders-h</v-icon>
                      </template>

                      <template v-slot:item.identify_name="{ item }">
                        <span v-if="!item.index" class="text-no-wrap">
                          {{ item.identify_name }}
                        </span>
                      </template>
                      <template v-slot:item.identify_code="{ item }">
                        <span class="text-no-wrap">
                          {{ item.identify_code }}
                        </span>
                        <br />
                        <span v-if="item.stock">
                          {{ item.stock.name }}
                        </span>
                      </template>
                      <template v-slot:item.status="{ item }">
                        <div v-if="item.status >= 0" class="text-no-wrap">
                          <v-chip
                            v-if="
                              item.identify == 'orders' &&
                              (item.cancel_flg || item.error_flg)
                            "
                            small
                            label
                            outlined
                            color="danger"
                            class="me-1"
                          >
                            {{
                              item.cancel_flg
                                ? $t("CRUD.cancelled")
                                : $t("Order.redeliverError")
                            }}
                          </v-chip>
                          <v-chip
                            v-if="item.identify == 'orders'"
                            small
                            label
                            :color="item.status | orderStatusColor"
                            :text-color="item.status | orderStatusTextColor"
                            >{{ item.status | orderStatusText }}
                          </v-chip>
                          <v-chip
                            v-if="item.identify == 'stock-orders-out'"
                            small
                            label
                            :color="item.status | stockOrderOUTStatusColor"
                            :text-color="
                              item.status | stockOrderOUTStatusTextColor
                            "
                            >{{ item.status | stockOrderOUTStatusText }}
                          </v-chip>
                          <v-chip
                            v-if="item.identify == 'distributions'"
                            small
                            label
                            :color="item.status | distributionStatusColor"
                            :text-color="
                              item.status | distributionStatusTextColor
                            "
                            >{{ item.status | distributionStatusText }}
                          </v-chip>
                          <v-chip
                            v-if="item.identify == 'examines'"
                            small
                            label
                            :color="item.status | examineStatusColor"
                            :text-color="item.status | examineStatusTextColor"
                            >{{ item.status | examineStatusText }}
                          </v-chip>
                          <v-chip
                            v-if="item.identify == 'receipts'"
                            small
                            label
                            :color="item.pay_flg | billPayFlgsColor"
                            :text-color="item.pay_flg | billPayFlgsTextColor"
                            >{{ item.pay_flg | billPayFlgsText }}
                          </v-chip>
                          <v-chip
                            v-if="item.identify == 'receipts'"
                            small
                            label
                            class="ms-1"
                            :color="item.status | billStatusColor"
                            :text-color="item.status | billStatusTextColor"
                            >{{ item.status | billStatusText }}
                          </v-chip>
                        </div>
                      </template>
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          v-if="
                            item.identify != 'orders' &&
                            $permission.permissionAllow(item.controller, 'view')
                          "
                          small
                          outlined
                          color="info"
                          class="px-2 me-2"
                          :href="'/#/' + item.identify + '/' + item.id"
                        >
                          <v-icon x-small class="pe-1">fa-align-left</v-icon>
                          {{ $t("Opt.details") }}
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
                <v-tab-item v-if="order.invoice_url">
                  <v-card max-width="240">
                    <v-img
                      :src="order.invoice_url"
                      @click.stop="$showFullscreenImages([order.invoice_url])"
                    >
                    </v-img>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <!-- :style="'padding-top: ' + fixHeaderHeightInPx + 'px'" -->
      <div class="px-4 pb-4" v-resize="$mainResizer">
        <v-card class="px-4" v-resize="editDetailModeOnResize">
          <v-toolbar flat class="transparent-background-color">
            <v-row no-gutters align="center">
              <v-toolbar-title class="ms-n2">
                {{ $t("CRUD.details", [$t("Order.ObjectName")]) }}
              </v-toolbar-title>
              <v-spacer />
              <span
                v-if="savable"
                class="secondary--text text-subtitle-2 font-weight-bold"
              >
                {{ $t("Order.Fields.price_in_edit") }}{{ $t("Global.colon") }}
              </span>
              <span
                v-if="savable"
                class="accent--text text-subtitle-2 font-weight-bold"
              >
                {{ $t("Global.money") }}{{ price_fix | moneyFormat }}
              </span>
              <v-btn-toggle
                v-if="
                  savable &&
                  edit_details_mode_enable &&
                  order.coupon_detail_id == null
                "
                v-model="edit_details_mode"
                dense
                mandatory
                color="primary"
                class="ms-4"
              >
                <v-btn small>{{ $t("Order.editDetailsMode.bySearch") }}</v-btn>
                <v-btn small>{{
                  $t("Order.editDetailsMode.byCategories")
                }}</v-btn>
              </v-btn-toggle>
            </v-row>
          </v-toolbar>
          <v-divider />
          <ValidationObserver ref="observer">
            <v-data-table
              v-show="!savable || edit_details_mode == 0"
              id="order_details_table"
              :headers="detailsHeaders"
              :items="orderDetails"
              :search="filter"
              multi-sort
              disable-pagination
              hide-default-footer
              :no-data-text="$t('Order.DetailNoData')"
              class="pb-2"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                >
                  <v-row no-gutters class="me-n3">
                    <span class="caption secondary--text pt-2">
                      {{
                        $t(
                          "$vuetify.dataFooter.pageText",
                          orderDetails
                            ? [
                                orderDetails.length > 0 ? 1 : 0,
                                orderDetails.length,
                                orderDetails.length,
                              ]
                            : [0, 0, 0]
                        )
                      }}
                    </span>
                    <v-row no-gutters>
                      <v-spacer />
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="filter"
                          clearable
                          hide-details
                          :label="$t('Search.filter')"
                        />
                      </v-col>
                    </v-row>
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:header.actions="{ header }">
                {{ header.text }}
                <v-icon x-small>fa-sliders-h</v-icon>
              </template>

              <template v-slot:item.category_name="{ item }">
                <span class="text-no-wrap">
                  <v-icon x-small>
                    {{
                      item.combineFlg
                        ? "fa-box"
                        : item.hide_flg
                        ? "fa-eye-slash"
                        : "fa-eye"
                    }}
                  </v-icon>
                  {{
                    item.combineFlg
                      ? $t("Material.Fields.combine_material")
                      : item.category_name
                  }}
                </span>
              </template>
              <template v-slot:item.material_name="{ item }">
                <v-chip
                  color="blue lighten-1"
                  label
                  x-small
                  text-color="white"
                  v-if="item.campaign"
                  style="
                    -webkit-transform: scale(0.7);
                    -webkit-transform-origin: 0 0;
                  "
                >
                  {{ item.campaign ? item.campaign.name : "" }}
                </v-chip>
                <br v-if="item.campaign" />
                <span
                  v-if="item.combineFlg"
                  class="text-no-wrap"
                  :class="item.error_flg ? 'red--text' : ''"
                >
                  {{ item.ruler_name }}
                </span>
                <span
                  v-else
                  class="text-no-wrap"
                  :class="item.error_flg ? 'red--text' : ''"
                >
                  {{ item.material_name }}
                </span>
                <br />
                <span v-if="item.standard_name" class="caption secondary--text">
                  {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")
                  }}<span
                    v-if="item.standard_name && item.standard_name.length > 12"
                    :title="item.standard_name"
                    style="cursor: pointer"
                  >
                    {{ item.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ item.standard_name }}
                  </span>
                </span>
                <span
                  v-if="item.combine_material"
                  class="caption secondary--text"
                >
                  <span
                    v-for="(detail, index) in item.combine_material.details"
                    :key="index"
                  >
                    {{ index == 0 ? "(" : "" }}{{ detail.material_name }}x{{
                      detail.combine_num
                    }}{{detail.unit}}{{
                      index != item.combine_material.details.length - 1
                        ? ","
                        : ")"
                    }}
                  </span>
                </span>
              </template>
              <template v-slot:item.available_quantity="{ item }">
                <span v-if="item.combineFlg && item.combine_material">
                  <span
                    v-if="
                      item.combine_material &&
                      'available_num' in item.combine_material &&
                      (item.combine_material.available_num != null ||
                        item.combine_material.available_num != undefined ||
                        item.combine_material.available_num != 'undefined')
                    "
                  >
                    {{ item.combine_material.available_num | formatTwoDot }}
                  </span>
                  <span v-else-if="accountSettings && accountSettings.oversell_setting == 1">
                    {{ $t("Order.DetailFields.no_limit") }}
                    <!-- 只在防超卖情况下显示“不限制” -->
                  </span>
                </span>
                <div
                  v-if="
                    (item.material = materials.find(
                      (material) => material.material_id == item.material_id
                    ))
                  "
                >
                  <span v-if="$i18n.locale == 'zhHans'">
                    <span v-if="accountSettings && accountSettings.oversell_setting == 1">
                      <span
                        v-if="
                          item.material &&
                          'available_num' in item.material &&
                          (item.material.available_num != null ||
                            item.material.available_num != undefined ||
                            item.material.available_num != 'undefined')
                        "
                      >
                        <span v-if="item.rate > 1">
                          {{
                            item.material.supply_available_num | formatTwoDot
                          }}
                          {{ item.material.unit }}
                        </span>
                        <span v-else>
                          {{ item.material.available_num | formatTwoDot }}
                          {{ item.material.default_unit }}
                        </span>
                      </span>
                      <span v-else>
                        {{ $t("Order.DetailFields.no_limit") }}
                      </span>
                    </span>
                    <span v-else>
                      <span v-if="item.rate > 1">
                        {{ item.current_count_rate_with_unit }}
                      </span>
                      <span v-else-if="item.material">
                        {{ item.material.current_count | formatTwoDot }}
                        {{ item.material.default_unit }}
                      </span>
                    </span>
                  </span>
                  <span v-else>
                    <span v-if="accountSettings && accountSettings.oversell_setting == 1">
                      <span
                        v-if="
                          item.material &&
                          'supply_available_num' in item.material &&
                          (item.material.supply_available_num != null ||
                            item.material.supply_available_num != undefined ||
                            item.material.supply_available_num != 'undefined')
                        "
                      >
                        <span v-if="item.rate > 1">
                          <span class="text-no-wrap caption font-weight-bold">
                            {{
                              item.material.supply_available_num | formatTwoDot
                            }}
                          </span>
                          <br />
                          <span class="text-no-wrap caption secondary--text">
                            {{ item.material.unit }}
                          </span>
                        </span>
                        <span v-else>
                          <span class="text-no-wrap caption font-weight-bold">
                            {{ item.material.available_num | formatTwoDot }}
                          </span>
                          <br />
                          <span class="text-no-wrap caption secondary--text">
                            {{ item.material.default_unit }}
                          </span>
                        </span>
                      </span>
                      <span v-else>
                        {{ $t("Order.DetailFields.no_limit") }}
                      </span>
                    </span>
                    <span v-else>
                      <span v-if="item.rate > 1">
                        <span class="text-no-wrap caption font-weight-bold">
                          {{ item.current_count_rate | formatTwoDot }}
                        </span>
                        <br />
                        <span class="text-no-wrap caption secondary--text">
                          {{ item.unit }}
                        </span>
                      </span>
                      <span v-else>
                        <span class="text-no-wrap caption font-weight-bold">
                          {{
                            item.material.current_count | formatTwoDot(2, true)
                          }}
                        </span>
                        <br />
                        <span class="text-no-wrap caption secondary--text">
                          {{ item.material.default_unit }}
                        </span>
                      </span>
                    </span>
                  </span>
                </div>
              </template>
              <template v-slot:item.material.multiple="{ item }">
                <span v-if="item.combineFlg">1</span
                ><!-- 组合商品默认倍数1 -->
                <span v-else-if="item.material && item.material.multiple">
                  {{ item.material.multiple | formatTwoDot }}
                </span>
                <span v-else>
                  {{ $t("Order.DetailFields.no_limit") }}
                </span>
              </template>
              <template v-slot:item.max_min="{ item }">
                <span
                  v-if="
                    item.combine_material && Number(item.combine_material.max)
                  "
                >
                  {{ item.combine_material.max | formatTwoDot }}
                </span>
                <span
                  v-else-if="item.material && Number(item.material.min_num)"
                >
                  {{ item.material.min_num | formatTwoDot }}
                </span>
                <span v-else>
                  {{ $t("Order.DetailFields.no_limit") }}
                </span>
              </template>
              <template v-slot:item.apply_num="{ item }">
                <ValidationProvider
                  v-if="!preview && savable"
                  v-slot="{ errors }"
                  :rules="item.apply_num <= 0 ? null : itemApplyNumRules(item)"
                >
                  <NumberInput
                    v-model="item.apply_num"
                    :error-messages="errors"
                    dense
                    @input="updateItemSums()"
                  />
                </ValidationProvider>
                <span v-else>
                  {{ item.apply_num | formatTwoDot }}
                </span>
              </template>
              <template v-slot:item.confirm_num="{ item }">
                <ValidationProvider
                  v-if="!preview && mode == 'confirm'"
                  v-slot="{ errors }"
                  :rules="
                    item.confirm_num <= 0 ? null : itemApplyNumRules(item)
                  "
                >
                  <NumberInput
                    v-model="item.confirm_num"
                    :disabled="
                      (isDisabled && item.price != 0) ||
                      (!!item.campaign && !item.new) ||
                      !!order.coupon_detail_id
                    "
                    :error-messages="errors"
                    dense
                    @input="updateItemSums()"
                  />
                </ValidationProvider>
                <span v-else>
                  {{ item.confirm_num | formatTwoDot }}
                </span>
              </template>
              <template v-slot:item.add_num="{ item }">
                <ValidationProvider
                  v-if="!preview && mode == 'edit'"
                  v-slot="{ errors }"
                  :rules="
                    item.add_num <= 0 ? null : itemApplyNumRules(item, true)
                  "
                >
                  <NumberInput
                    v-model="item.add_num"
                    dense
                    :disabled="
                      (isDisabled && item.price != 0) ||
                      (!!item.campaign && !item.new) ||
                      !!order.coupon_detail_id
                    "
                    :error-messages="errors"
                    allow-negative
                    :min="0 - Number(item.confirm_num)"
                    @input="updateItemSums()"
                  />
                </ValidationProvider>
                <span v-else>
                  {{ item.add_num | formatTwoDot(true) }}
                </span>
              </template>
              <template v-slot:item.fix_num="{ item }">
                {{ item.fix_num | formatTwoDot }}
              </template>
              <template v-slot:item.unitAndBarcode="{ item }">
                <!-- 计数单位开启后显示计数单位 -->
                <span
                  v-if="
                    accountSettings &&
                    accountSettings.count_unit == 1 &&
                    item.count_unit &&
                    item.count_unit_rate
                  "
                >
                  {{ item.count_unit }}
                </span>
                <span v-else>
                  {{ item.unit }}
                  <span
                    v-if="item.material && item.rate > 1"
                    class="caption secondary--text"
                  >
                    (1{{ item.unit }}={{ item.rate
                    }}{{ item.material.default_unit }})
                  </span>
                  <span
                    v-else-if="
                      item.material &&
                      item.standard_detail &&
                      item.standard_detail.rate > 1
                    "
                    class="caption secondary--text"
                  >
                    (1{{ item.unit }}={{ item.standard_detail.rate
                    }}{{ item.material.default_unit }})
                  </span>
                  <span
                    v-if="
                      item.barcode ||
                      (item.standard_detail && item.standard_detail.barcode)
                    "
                    class="caption secondary--text"
                  >
                    <br />
                    {{
                      item.barcode
                        ? item.barcode
                        : item.standard_detail
                        ? item.standard_detail.barcode
                        : ""
                    }}
                  </span>
                </span>
              </template>
              <template v-slot:item.gross_weight="{ item }">
                <span
                  v-if="
                    item.combineFlg &&
                    item.combine_material &&
                    item.combine_material.total_weight
                  "
                >
                  {{
                    (item.combine_material.total_weight * item.fix_num)
                      | formatTwoDot
                  }}kg
                  <!-- 组合商品明细，全部转化为千克重量 -->
                </span>
                <span
                  v-else-if="
                    !item.combineFlg &&
                    item.standard_detail &&
                    item.standard_detail.gross_weight
                  "
                >
                  {{
                    (item.standard_detail.gross_weight * item.fix_num)
                      | formatTwoDot
                  }}{{ item.standard_detail.gross_weight_unit
                  }}<span
                    v-if="
                      item.standard_detail.gross_weight_config &&
                      item.standard_detail.gross_weight_unit != 'kg'
                    "
                    class="caption secondary--text"
                    >({{
                      ((item.standard_detail.gross_weight *
                        item.standard_detail.gross_weight_config.weight_rate *
                        item.fix_num) /
                        1000)
                        | formatTwoDot
                    }}kg)</span
                  >
                  <!-- 已经产生的订单明细 -->
                </span>
                <span
                  v-else-if="
                    !item.combineFlg &&
                    item.material &&
                    item.material.gross_weight
                  "
                >
                  {{ (item.material.gross_weight * item.fix_num) | formatTwoDot
                  }}{{ item.material.gross_weight_unit
                  }}<span
                    v-if="item.material.gross_weight_unit != 'kg'"
                    class="caption secondary--text"
                    >({{
                      ((item.material.gross_weight *
                        item.material.gross_weight_rate *
                        item.fix_num) /
                        1000)
                        | formatTwoDot
                    }}kg)</span
                  >
                  <!-- 订单新增和编辑时的新条目明细 -->
                </span>
              </template>
              <template v-slot:item.price="{ item }">
                <span>
                  {{ $t("Global.money") }}{{ item.price | moneyFormat }}
                </span>
              </template>
              <template v-slot:item.sum="{ item }">
                {{ $t("Global.money")
                }}{{ item.total > 0 ? item.total : item.sum | moneyFormat }}
              </template>
              <template v-slot:item.memo="{ item }">
                <v-text-field
                  v-if="savable"
                  v-model="item.memo"
                  single-line
                  dense
                  hide-details
                  style="max-width: 120px"
                >
                  <template v-slot:append>
                    <v-icon
                      x-small
                      @click.stop="
                        detail_memo_item = item;
                        memo_dialog = true;
                      "
                      class="pt-2 pb-1 primary--text"
                    >
                      fa-edit
                    </v-icon>
                  </template>
                </v-text-field>
                <span v-else>
                  {{ item.memo }}
                </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  v-if="item.new"
                  small
                  text
                  class="danger--text pa-0"
                  @click.stop="
                    item.combineFlg
                      ? order_combine_materials.splice(
                          order_combine_materials.findIndex(
                            (detail) => item.ruler_id == detail.ruler_id
                          ),
                          1
                        )
                      : order_details.splice(
                          order_details.findIndex((detail) =>
                            item.id
                              ? item.id == detail.id
                              : item.material_id == detail.material_id &&
                                (item.auto_flg
                                  ? item.auto_flg == detail.auto_flg
                                  : detail.auto_flg == 0)
                          ),
                          1
                        );
                    updateItemSums();
                  "
                >
                  <v-icon>fa-times</v-icon>
                </v-btn>
              </template>

              <template v-slot:footer>
                <v-row
                  v-if="
                    shop.id &&
                    !preview &&
                    edit_details_mode == 0 &&
                    order.coupon_detail_id == null &&
                    (mode == 'new' ||
                      (mode == 'edit' && !isDisabled) ||
                      (mode == 'confirm' && !isDisabled))
                  "
                  no-gutters
                  align="center"
                  class="ps-1 text-no-wrap d-flex"
                >
                  <span class="secondary--text">
                    {{ $t("CRUD.newInfo", [$t("Material.ObjectName")]) }}{{ $t("Global.colon") }}
                  </span>
                  <keep-alive>
                    <SearcherTemplateMaterial
                      v-model="addMaterial"
                      :shop-id="shop ? shop.id : null"
                      :disabled-items="
                        orderDetails
                          ? orderDetails.map((detail) => {
                              return detail.combineFlg
                                ? {
                                    combineFlg: true,
                                    ruler_id: detail.ruler_id,
                                  }
                                : {
                                    material_id: detail.material_id,
                                    unit: detail.unit,
                                  };
                            })
                          : []
                      "
                      no-label
                      show-price
                      :show-available-quantity="
                        accountSettings && accountSettings.oversell_setting == 1
                      "
                      @loaded="
                        materials = $event;
                        loaded = true;
                      "
                      showByIdUnit
                    />
                  </keep-alive>
                </v-row>
                <v-row
                  v-if="
                    shop.id &&
                    !preview &&
                    edit_details_mode == 0 &&
                    ((mode == 'edit' && isDisabled) ||
                      (mode == 'confirm' && isDisabled))
                  "
                  no-gutters
                  align="center"
                  class="ps-1 text-no-wrap d-flex"
                >
                  <span class="secondary--text">
                    {{ $t("Order.actions.addFreeMaterial") }}{{ $t("Global.colon") }}
                  </span>
                  <keep-alive>
                    <SearcherTemplateFreeMaterial
                      v-model="addMaterial"
                      :shop-id="shop ? shop.id : null"
                      :disabled-items="
                        orderDetails
                          ? orderDetails.map((detail) => {
                              return detail.combineFlg
                                ? {
                                    combineFlg: true,
                                    ruler_id: detail.ruler_id,
                                  }
                                : { material_id: detail.material_id };
                            })
                          : []
                      "
                      no-label
                      show-price
                      :show-available-quantity="
                        accountSettings && accountSettings.oversell_setting == 1
                      "
                      @loaded="
                        materials = $event;
                        loaded = true;
                      "
                    />
                  </keep-alive>
                </v-row>
                <v-divider v-if="!savable" />
                <v-row no-gutters v-if="!savable">
                  <v-spacer />
                  <v-col cols="12" sm="6" md="3">
                    <v-list-item>
                      <v-list-item-content>
                        <span class="secondary--text">
                          {{ $t("Order.Fields.price_fix") }}
                        </span>
                      </v-list-item-content>
                      <v-list-item-content class="align-end text-end">
                        <span>
                          {{ $t("Global.money")
                          }}{{ order.price_fix | moneyFormat }}
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <span class="secondary--text">
                          {{ $t("Order.Fields.price_cut") }}
                        </span>
                        <span
                          class="secondary--text"
                          v-if="!!order.coupon_detail_id"
                        >
                          ({{ $t("Order.Fields.coupon_cut") }})
                        </span>
                      </v-list-item-content>
                      <v-list-item-content class="align-end text-end">
                        <span v-if="order.price_cut < 0">
                          + {{ $t("Global.money")
                          }}{{ (0 - order.price_cut) | moneyFormat }}
                        </span>
                        <span v-else-if="order.price_cut == 0">
                          {{ $t("Global.money")
                          }}{{ order.price_cut | moneyFormat }}
                        </span>
                        <span v-else>
                          - {{ $t("Global.money")
                          }}{{ order.price_cut | moneyFormat }}
                        </span>
                        <span v-if="!!order.coupon_detail_id">
                          ({{ $t("Global.money")
                          }}{{ order.total_coupon_price | moneyFormat }})
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <span class="secondary--text">{{ $t("Order.Fields.express_price") }}</span>
                      </v-list-item-content>
                      <v-list-item-content class="align-end text-end">
                        <span>
                          {{ $t("Global.money") }}
                          {{ order.express_price | moneyFormat }}
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="order.weight_total > 0">
                      <v-list-item-content>
                        <span class="secondary--text">
                          {{ $t("Order.DetailFields.gross_weight") }}
                        </span>
                      </v-list-item-content>
                      <v-list-item-content class="align-end text-end">
                        <span>
                          {{
                            $t("Order.Fields.weight_total_unit", [
                              $numberFormatter.formatTwoDot(order.weight_total),
                            ])
                          }}
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      v-if="
                        edit_express &&
                        (mode == 'edit' || mode == 'confirm' || isView)
                      "
                      class="mt-n8"
                    >
                      <v-spacer />
                      <span class="caption orange--text">
                        {{
                          isView
                            ? $t("Order.messages.viewModeEditExpressPriceHint")
                            : $t("Order.messages.editExpressPriceHint")
                        }}
                      </span>
                    </v-list-item>
                    <v-divider />
                    <v-list-item>
                      <v-list-item-content>
                        <span class="secondary--text font-weight-bold">
                          {{ $t("Order.Fields.order_price") }}
                        </span>
                      </v-list-item-content>
                      <v-list-item-content class="align-end text-end">
                        <span class="accent--text font-weight-bold">
                          {{ $t("Global.money")
                          }}{{ order.order_price | moneyFormat }}
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider />
                  </v-col>
                </v-row>
              </template>
              <!-- 合计 -->
              <template v-slot:body.prepend>
                <tr class="d-none d-sm-table-row">
                  <td>
                    <span>{{ $t("TableSum") }}</span>
                  </td>
                  <td
                    :colspan="
                      (isNew
                        ? detailsHeaders.findIndex(
                            (h) => h.value == 'apply_num'
                          )
                        : detailsHeaders.findIndex(
                            (h) => h.value == 'apply_num'
                          )) - 1
                    "
                  ></td>
                  <td :align="$vuetify.rtl ? 'left' : 'right'">
                    {{ order.details_num | formatTwoDot }}
                  </td>
                  <td></td>
                  <td align="center">
                    {{
                      order.weight_total > 0
                        ? $t("Order.Fields.weight_total_unit", [
                            $numberFormatter.formatTwoDot(order.weight_total),
                          ])
                        : "-"
                    }}
                  </td>
                  <td colspan="2"></td>
                  <td v-if="accountSettings && accountSettings.order_detail_memo"></td>
                  <td v-if="savable && !preview"></td>
                </tr>
                <tr class="d-table-row d-sm-none">
                  <td class="v-data-table__mobile-row">
                    <div class="v-data-table__mobile-row__header">
                      {{ $t("TableSum") }}
                    </div>
                  </td>
                  <td class="v-data-table__mobile-row" v-if="!isNew">
                    <div class="v-data-table__mobile-row__header">
                      {{ $t("Order.DetailFields.apply_num") }}
                    </div>
                    <div class="v-data-table__mobile-row__cell">
                      {{ order.apply_num_total | formatTwoDot }}
                    </div>
                  </td>
                  <td class="v-data-table__mobile-row" v-if="!isNew">
                    <div class="v-data-table__mobile-row__header">
                      {{ $t("Order.DetailFields.confirm_num") }}
                    </div>
                    <div class="v-data-table__mobile-row__cell">
                      {{ order.confirm_num_total | formatTwoDot }}
                    </div>
                  </td>
                  <td class="v-data-table__mobile-row">
                    <div class="v-data-table__mobile-row__header">
                      {{
                        isNew
                          ? $t("Order.DetailFields.apply_num")
                          : $t("Order.DetailFields.fix_num")
                      }}
                    </div>
                    <div class="v-data-table__mobile-row__cell">
                      {{ order.details_num | formatTwoDot }}
                    </div>
                  </td>
                  <td class="v-data-table__mobile-row">
                    <div class="v-data-table__mobile-row__header">
                      {{ $t("Order.DetailFields.gross_weight") }}
                    </div>
                    <div class="v-data-table__mobile-row__cell">
                      {{
                        order.weight_total > 0
                          ? $t("Order.Fields.weight_total_unit", [
                              $numberFormatter.formatTwoDot(order.weight_total),
                            ])
                          : "-"
                      }}
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </ValidationObserver>

          <keep-alive>
            <CardTemplateMaterials
              v-if="savable && edit_details_mode == 1"
              class="hidden-print pb-2"
              v-model="orderDetails"
              :shop-id="shop ? shop.id : null"
              :mode="mode"
              @add="addDetail($event)"
              @update="updateItemSums()"
              @memo="
                detail_memo_item = $event;
                memo_dialog = true;
              "
            />
          </keep-alive>
        </v-card>
      </div>
    </v-sheet>

    <v-dialog v-model="memo_dialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span
            class="red--text d-inline-block text-truncate"
            style="max-width: 360px"
          >
            {{
              $t("Material.materialNameWithCode", [
                detail_memo_item.material_code,
                detail_memo_item.material_name,
              ])
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memo_dialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-model="memo_dialog_memo"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
          <SearcherDatetime
            class="my-n2"
            v-if="savable && detail_memo_item.delivery_date_flg"
            v-model="memo_dialog_expect_date"
            type="date"
            :disabled-before-today="isNew"
            :label="$t('Order.DetailFields.expect_date')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memo_dialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="UploadDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("Import.import", [$t("Order.Fields.invoice")]) }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="UploadDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="text-left my-2">
                {{ $t("Import.uploadField", [$t("Order.Fields.invoice")]) }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-card v-if="invoice_img" max-width="240">
                  <v-img
                    :src="invoice_img"
                    @click.stop="$showFullscreenImages([invoice_img])"
                  >
                    <v-tooltip right v-if="savable && invoice_img">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="secondary"
                          class="pa-2 float-right"
                          @click.stop="
                            !invoice_img.startsWith('data:image/') &&
                            invoice_img == invoice.invoice_img
                              ? (invoice.invoice_img = invoice_img = null)
                              : (invoice_img = null)
                          "
                        >
                          fa-times
                        </v-icon>
                      </template>
                      <span> {{ $t("Material.delImg") }}</span>
                    </v-tooltip>
                  </v-img>
                </v-card>
                <v-file-input
                  ref="invoice_img_file"
                  show-size
                  prepend-icon="fa-camera"
                  accept="image/png, image/jpeg"
                  persistent-hint
                  :placeholder="$t('Material.imgPlaceholder')"
                  :hint="$t('Material.imgHint')"
                  :rules="imgRules"
                  v-model="invoice_img_file"
                >
                </v-file-input>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="UploadDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="primary" depressed @click="submitUploadInvoiceImg()">
            {{ $t("Import.confirmImport") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MaterialDialog v-model="dialogMaterialID" />
    <CombineMaterialDialog
      v-model="dialogCombineMaterial"
      @dialogMaterialID="dialogMaterialID = $event"
    />

    <ErrorMaterialsAlert
      v-model="errorMaterialInfoAlert"
      :message="errorMaterialInfoMessage"
      :materialArr="errorMaterialsList"
      :group="showGroupRow"
    />
    <OverSellMaterial
      v-model="overSellErrorFlg"
      :material="overSellMaterials"
    />
    <!-- 分发出错商品错误提示 -->
    <RedeliverErrorAlert
      v-model="redeliverErrorDialog"
      :Items="redeliverErrorData"
    />
    <!-- 选择客户地址的弹窗 -->
    <DialogShopAddress
      v-model="selectShopAddressDialog"
      :order_extra="order.order_extra ? order.order_extra : {}"
      @confirm="selectShopAddress = $event"
      isActivity
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import OrderActions from "./plugins/Actions";
// import SearcherShop from "@/components/plugins/SearcherShop";
// import SearcherKeyword from "@/components/plugins/SearcherKeyword";
// import DialogShop from "@/components/plugins/DialogShop";
import DialogShopAddress from "@/components/plugins/DialogShopAddress"
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import SearcherTemplateMaterial from "@/components/plugins/SearcherTemplateMaterial";
import SearcherTemplateFreeMaterial from "@/components/plugins/SearcherTemplateFreeMaterial";
import NumberInput from "@/components/plugins/NumberInput";
import MaterialDialog from "@/components/materials/plugins/Dialog";
import CombineMaterialDialog from "./plugins/CombineMaterialDialog";
import ErrorMaterialsAlert from "./plugins/ErrorMaterialsAlert";
import CardTemplateMaterials from "./plugins/CardTemplateMaterials";
import Orders from "@/api/orders";
import MaterialTemplates from "@/api/material_templates";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Files from "@/api/files";
import Shops from "@/api/shops";
import OverSellMaterial from "./plugins/OverSellMaterial";
import RedeliverErrorAlert from "./plugins/RedeliverErrorAlert";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    OrderActions,
    // SearcherShop,
    // SearcherKeyword,
    // DialogShop,
    DialogShopAddress,
    SearcherDatetime,
    SearcherTemplateMaterial,
    SearcherTemplateFreeMaterial,
    NumberInput,
    MaterialDialog,
    CombineMaterialDialog,
    ErrorMaterialsAlert,
    CardTemplateMaterials,
    ValidationObserver,
    ValidationProvider,
    OverSellMaterial,
    RedeliverErrorAlert,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view" || this.mode == "approve";
    },
    savable() {
      return (
        !this.preview &&
        (this.mode == "new" || this.mode == "edit" || this.mode == "confirm")
      );
    },
    isNew() {
      return this.mode == "new";
    },
    isDisabled() {
      return !!(
        // !!确保数据类型变更为Boolean
        (
          !this.accountSettings ||
          (this.accountSettings.bill_credential_type.shop_bill == 19 &&
            this.accountSettings.bill_credential_type.order_edit == 0) ||
          // ↑账单依据未要货下单不可更改订单
          (this.accountSettings.sub_account_enable &&
            (!this.bill || this.bill.pay_flg != 0) &&
            this.shop.shop_pay_setting == 1)
        )
        // ↑如果开启了分账且门店为先款后货，要货单确认和编辑时不能做商品修改
      );
    },
    edit_details_mode_enable() {
      return (
        this.windowInnerWidth >= 600 &&
        !(
          !this.preview &&
          (this.mode == "edit" || this.mode == "confirm") &&
          this.isDisabled
        )
      );
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.orderManagement"),
          disabled: false,
          href: "/orders",
        },
        {
          text:
            this.mode == "confirm"
              ? i18n.t("Nav.orderConfirm")
              : this.mode == "approve"
              ? i18n.t("Nav.orderApprove")
              : this.isNew
              ? i18n.t("Nav.orderNew")
              : i18n.t("Nav.orderDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
            this.order && this.order.order_code ? this.order.order_code : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Order.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("Order.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("Order.DetailFields.material_name"),
          align: "start",
          value: "material_name",
        },
      ];
      if (
        this.accountInfo &&
        this.accountInfo.version &&
        (this.accountInfo.version.stock_type == 2 ||
          this.accountInfo.version.stock_type == 3)
      ) {
        headers.push({
          text: i18n.t(
            this.accountSettings && this.accountSettings.oversell_setting == 1
              ? "Order.DetailFields.available_quantity"
              : "Order.DetailFields.current_quantity"
          ),
          align: "end",
          value: "available_quantity",
        });
      }
      headers.push(
        {
          text: i18n.t("Order.DetailFields.order_multiple"),
          align: "end",
          value: "material.multiple",
        },
        // {
        //   text: i18n.t("Order.DetailFields.order_max_min_number"),
        //   align: "end",
        //   value: "max_min",
        // },
        {
          text: i18n.t("Order.DetailFields.apply_num"),
          align: "end",
          value: "apply_num",
          sortable: false,
        }
      );
      // if (!this.isNew) {
      //   headers.push({
      //     text: i18n.t("Order.DetailFields.confirm_num"),
      //     align: "end",
      //     value: "confirm_num",
      //     sortable: false,
      //   });
      //   if (this.mode == "edit")
      //     headers.push({
      //       text: i18n.t("Order.DetailFields.add_num"),
      //       align: "end",
      //       value: "add_num",
      //       sortable: false,
      //     });
      //   headers.push({
      //     text: i18n.t("Order.DetailFields.fix_num"),
      //     align: "end",
      //     value: "fix_num",
      //     sortable: false,
      //   });
      // }
      headers.push({
        text: i18n.t("Order.DetailFields.unit"),
        align: "center",
        value: "unitAndBarcode",
      });
      headers.push({
        text: i18n.t("Order.DetailFields.gross_weight"),
        align: "center",
        value: "gross_weight",
      });
      headers.push({
        text: i18n.t("Order.DetailFields.price"),
        align: "end",
        value: "price",
        sortable: false,
      });
      headers.push({
        text: i18n.t("Order.DetailFields.sum"),
        align: "end",
        value: "sum",
      });
      if (this.accountSettings && this.accountSettings.order_detail_memo)
        headers.push({
          text: i18n.t("Order.DetailFields.memo"),
          align: "start",
          sortable: false,
          value: "memo",
        });
      if (this.savable && !this.preview)
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("Order.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("Order.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("Order.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    relationsHeaders: () => [
      {
        text: i18n.t("Order.RelationFields.identify_name"),
        align: "center",
        sortable: false,
        value: "identify_name",
      },
      {
        text: i18n.t("Order.RelationFields.identify_code"),
        align: "center",
        sortable: false,
        value: "identify_code",
      },
      {
        text: i18n.t("Order.RelationFields.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("Order.RelationFields.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("Order.RelationFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    orderDetails() {
      var items = this.order_combine_materials.map((combineDetail) => {
        combineDetail.combineFlg = true;
        if (combineDetail.combine_material) {
          combineDetail.price = combineDetail.combine_material.price;
        }
        combineDetail.sum = combineDetail.price * combineDetail.apply_num;
        return combineDetail;
      });
      this.order_details
        .filter(
          (detail) =>
            (!this.savable || !detail.auto_flg) && detail.auto_flg != 3 // 组合商品的详情不显示
        )
        .forEach((detail) => {
          //拼接商品的下单单位和单位条形码，便于table的filter筛选
          detail.unitAndBarcode = "";
          if (detail.standard_detail) {
            detail.unitAndBarcode =
              "(" +
              detail.standard_detail.barcode +
              ")" +
              detail.standard_detail.unit;
          }
          detail.sum = this.$numberFormatter.moneyFormat(
            parseFloat((detail.price * detail.fix_num).toFixed(4))
          );
          // 商品多单位，商品id拼接单位
          if (detail.material_id && detail.unit) {
            detail.material_id_unit = detail.material_id + "-" + detail.unit;
          }
          items.push(detail);
        });
      if (items.length) {
        let priceFix = 0;
        items.forEach((item) => {
          priceFix += parseFloat(item.sum);
          priceFix = parseFloat(priceFix.toFixed(2)); //解决精度丢失
          if (this.savable) {
            // 非编辑模式整单价格以接口返回为准，不作调整
            this.order.price_fix = this.price_fix = priceFix;
            if (this.order.order_price) {
              this.order.price_cut =
                this.order.order_price - this.order.price_fix;
            }
          }
        });
      }

      return items;
    },
    // accountID() {
    //   return this.accountInfo ? this.accountInfo.account_id : "";
    // },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState([
      "loading",
      "mainContentScrolled",
      "fixHeaderHeightInPx",
      "accountSettings",
      "accountUser",
      "userType",
    ]),
  },

  mounted() {
    if (this.$route.path.startsWith("/order-new")) {
      this.mode = "new";
    } else {
      this.mode = this.$route.params.mode;
      if (this.mode) this.$router.replace("/orders/" + this.$route.params.id);
    }

    if (localStorage.getItem("order_new_details_mode"))
      this.edit_details_mode = Number(
        localStorage.getItem("order_new_details_mode")
      );
  },

  data: () => ({
    panels: [0],
    tab: null,
    mode: "",
    windowInnerWidth: 599, //默认先不开模式切换，等Resize后确认实际值
    edit_details_mode: 1, // 0搜索、1全部、2……尚无
    serverErrors: [],
    shop: {},
    order: {},
    price_fix: 0,
    bill: {},
    addMaterial: null,
    materials: [],
    order_combine_materials: [],
    order_details: [],
    order_activities: [],
    order_relations: [],
    preview: false,
    orderBeforPreview: null,
    filter: "",
    memo_dialog: false,
    memo_dialog_expect_date: null,
    memo_dialog_memo: "",
    detail_memo_item: { memo: "" },
    dialogMaterialID: null,
    dialogCombineMaterial: null,
    thirdAccessToken: "",
    UploadDialog: false,
    imgRules: [
      (value) => !value || value.size < 5000000 || i18n.t("Material.imgHint"),
    ],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.imgsHint"),
    ],
    invoice_img: "",
    invoice_img_file: null,
    errorMaterialInfoAlert: false,
    errorMaterialInfoMessage: "",
    errorMaterialsList: [],
    showGroupRow: false,
    edit_express: false,
    album: [],
    imgs_file: [],
    overSellMaterials: [],
    overSellErrorFlg: false,
    loaded: false,
    redeliverErrorDialog: false,
    redeliverErrorData: [],
    selectShopAddressDialog: false,
    selectShopAddress: null,
  }),

  methods: {
    itemApplyNumRules(item, addMode) {
      var rules = {};
      var max = 0;
      var available_num = 0;
      if (item.material) {
        if (Number(item.material.multiple))
          rules.multiple = { multiple: item.material.multiple };
        if (Number(item.material.min_num))
          rules.min_value = {
            min:
              addMode && item.confirm_num
                ? item.material.min_num - item.confirm_num
                : item.material.min_num,
          };
        max = Number(item.material.max_num ? item.material.max_num : 0);
        available_num =
          item.material &&
          "available_num" in item.material &&
          item.material.available_num != null &&
          item.material.available_num != undefined &&
          item.material.available_num != "undefined"
            ? Number(item.material.available_num)
            : null;
        if (item.rate > 1)
          available_num =
            item.material &&
            "supply_available_num" in item.material &&
            item.material.supply_available_num != null &&
            item.material.supply_available_num != undefined &&
            item.material.supply_available_num != "undefined"
              ? Number(item.material.supply_available_num)
              : null;
        if (available_num != null && this.mode == "confirm")
          available_num = available_num + (item.apply_num ? item.apply_num : 0);
        if (available_num != null && this.mode == "edit")
          available_num = available_num + (item.add_num_org ? item.add_num_org : 0);//可售数量加上追加数量
        if (max && available_num != null)
          rules.max_value = {
            max:
              addMode && item.confirm_num
                ? Math.min(max - item.confirm_num, available_num)
                : Math.min(max, available_num),
          };
        else if (max)
          rules.max_value = {
            max: addMode && item.confirm_num ? max - item.confirm_num : max,
          };
        else if (available_num != null)
          rules.max_value = {
            max: available_num,
          };
      } else if (item.combineFlg) {
        rules.multiple = { multiple: 1 }; //组合商品默认倍数1
        if (item.combine_material) {
          max = Number.parseInt(
            item.combine_material.max ? item.combine_material.max : 0
          );
          available_num =
            item.combine_material &&
            "available_num" in item.combine_material &&
            item.combine_material.available_num != null &&
            item.combine_material.available_num != undefined &&
            item.combine_material.available_num != "undefined"
              ? Number.parseInt(item.combine_material.available_num)
              : null;
          if (available_num != null && this.mode == "confirm")
            available_num =
              available_num + (item.apply_num ? item.apply_num : 0);
          if (max && available_num != null)
            rules.max_value = {
              max:
                addMode && item.confirm_num
                  ? Math.min(max - item.confirm_num, available_num)
                  : Math.min(max, available_num),
            };
          else if (max)
            rules.max_value = {
              max: addMode && item.confirm_num ? max - item.confirm_num : max,
            };
          else if (available_num != null)
            rules.max_value = {
              max: available_num,
            };
        }
      }
      return rules;
    },
    editDetailModeOnResize() {
      this.windowInnerWidth = window.innerWidth;
    },

    getOrderFromAPI() {
      Orders.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.order = response.data.order;
            this.album = response.data.order.order_img;
            if (this.order && this.order.order_details) {
              this.order.order_details.forEach((detail) => {
                if (this.accountSettings && this.accountSettings.count_unit == 1) {
                  // 开启计数单位的时候进行一个单位的换算
                  if (
                    detail.standard_detail &&
                    detail.standard_detail.count_unit_rate &&
                    detail.standard_detail.count_unit
                  ) {
                    detail.count_unit = detail.standard_detail.count_unit;
                    detail.price = detail.count_unit_price;
                    detail.count_unit_rate =
                      detail.standard_detail.count_unit_rate;
                    if (
                      detail.count_unit_apply_num ||
                      detail.count_unit_apply_num == 0
                    ) {
                      detail.apply_num = detail.count_unit_apply_num;
                    }
                    if (
                      detail.count_unit_confirm_num ||
                      detail.count_unit_confirm_num == 0
                    ) {
                      detail.confirm_num = detail.count_unit_confirm_num;
                    }
                    if (
                      detail.count_unit_add_num ||
                      detail.count_unit_add_num == 0
                    ) {
                      detail.add_num = detail.count_unit_add_num;
                    }
                    if (
                      detail.count_unit_fix_num ||
                      detail.count_unit_fix_num == 0
                    ) {
                      detail.fix_num = detail.count_unit_fix_num;
                    }
                  }
                }
                if (this.mode == "confirm") {
                  // 确认订单时默认填充核定数量
                  detail.confirm_num = detail.apply_num;
                }
                // 追加数量的校验最大值等于原有的追加数量加上可售数量
                detail.add_num_org = detail.add_num ? detail.add_num : 0;
              });
            }
            if (this.order && this.order.order_combine_materials) {
              this.order.order_combine_materials.forEach((combine_detail) => {
                if (this.mode == "confirm") {
                  // 确认订单时默认填充核定数量
                  combine_detail.confirm_num = combine_detail.apply_num;
                }
              });
            }

            this.order_activities = response.data.order_activities;
            if (!!this.order.coupon_detail_id && this.edit_details_mode != 0) {
              this.edit_details_mode = 0;
            }
          }
        }.bind(this)
      );

      if (this.$permission.permissionAllow("Orders", "relations")) {
        Orders.fetchRelations(this.$route.params.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.order_relations = [];
              this.order_relations.push(
                Object.assign(
                  {
                    controller: "Orders",
                    identify: "orders",
                    identify_name: i18n.t("Order.ObjectName"),
                    identify_code: response.data.order.order_code,
                  },
                  response.data.order
                )
              );
              response.data.stock_orders.forEach((stock_order, index) => {
                if (stock_order.status >= 0 || stock_order.status == -2)
                  this.order_relations.push(
                    Object.assign(
                      {
                        index: index,
                        controller: "StockOuts",
                        identify: "stock-orders-out",
                        identify_name: i18n.t("StockOrderOUT.ObjectName"),
                        identify_code: stock_order.stock_order_code,
                      },
                      stock_order
                    )
                  );
              });
              response.data.distributions.forEach((distribution, index) => {
                if (distribution.status >= 0 || distribution.status == -2)
                  this.order_relations.push(
                    Object.assign(
                      {
                        index: index,
                        controller: "Distributions",
                        identify: "distributions",
                        identify_name: i18n.t("Distribution.ObjectName"),
                        identify_code: distribution.distributions_code,
                      },
                      distribution
                    )
                  );
              });
              response.data.examines.forEach((examine, index) => {
                this.order_relations.push(
                  Object.assign(
                    {
                      index: index,
                      controller: "Examines",
                      identify: "examines",
                      identify_name: i18n.t("Examine.ObjectName"),
                      identify_code: examine.examine_code,
                      status: examine.is_examined,
                    },
                    examine
                  )
                );
              });
              this.order_relations.push(
                Object.assign(
                  {
                    controller: "Receipt",
                    identify: "receipts",
                    identify_name: i18n.t("Bill.ObjectName"),
                    identify_code: response.data.bill.bill_code,
                  },
                  response.data.bill
                )
              );
            }
          }.bind(this)
        );
      }
    },
    previewMethod() {
      if (this.isNew) return Orders.addPreview(this.order);
      else if (this.mode == "confirm") return Orders.confirmPreview(this.order);
      else if (this.mode == "edit") return Orders.editPreview(this.order);
    },
    submitMethod() {
      if (this.isNew) return Orders.add(this.order);
      else if (this.mode == "confirm") return Orders.confirm(this.order);
      else if (this.mode == "edit") return Orders.edit(this.order);
    },
    async doPreview() {
      this.$store.dispatch("fullscreenLoading");
      this.orderBeforPreview = JSON.stringify(this.order);
      if (this.isNew) {
        if (this.$refs.imgs_file.hasError) {
          this.$store.dispatch("fullscreenLoadingStop");
          return;
        }
        //提交图片集
        var order_img = [];
        if (this.imgs_file && this.imgs_file.length > 0) {
          let response = await Files.imagesUpload(
            this.imgs_file,
            false,
            "images"
          );

          if (response.data.status.isOK()) {
            response.data.data.forEach((img) => order_img.push(img.img_name));
          }
        }
        this.order = Object.assign({}, this.order, {
          order_img: order_img,
        });
      }
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            if (this.accountSettings && this.accountSettings.count_unit == 1) {
              this.order.order_details.forEach((detail) => {
                // 开启计数单位后,换算提交
                if (detail.count_unit && detail.count_unit_rate) {
                  detail.count_unit_price = detail.price;
                  detail.price = detail.price / detail.count_unit_rate;
                  if (detail.apply_num || detail.apply_num == 0) {
                    detail.count_unit_apply_num = detail.apply_num;
                    detail.apply_num =
                      detail.apply_num * detail.count_unit_rate;
                  }
                  if (detail.confirm_num || detail.confirm_num == 0) {
                    detail.count_unit_confirm_num = detail.confirm_num;
                    detail.confirm_num =
                      detail.confirm_num * detail.count_unit_rate;
                  }
                  if (detail.add_num || detail.add_num == 0) {
                    detail.count_unit_add_num = detail.add_num;
                    detail.add_num = detail.add_num * detail.count_unit_rate;
                  }
                  if (detail.fix_num || detail.fix_num == 0) {
                    detail.count_unit_fix_num = detail.fix_num;
                    detail.fix_num = detail.fix_num * detail.count_unit_rate;
                  }
                }
              });
            }
            this.previewMethod()
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.preview = true;
                    this.order = response.data.order;
                    // 开启计数单位后
                    // apply_num是页面显示数值，实际apply_num的意思是要货单位申请量，count_unit_apply_num是计数单位申请量
                    //获取数据后进行换算显示，页面上显示用的是apply_num一套的字段
                    if (this.accountSettings && this.accountSettings.count_unit == 1) {
                      this.order.order_details.map((detail) => {
                        if (detail.count_unit && detail.count_unit_rate) {
                          detail.price = detail.count_unit_price;
                          if (
                            detail.count_unit_apply_num ||
                            detail.count_unit_apply_num == 0
                          ) {
                            detail.apply_num = detail.count_unit_apply_num;
                          }
                          if (
                            detail.count_unit_confirm_num ||
                            detail.count_unit_confirm_num == 0
                          ) {
                            detail.confirm_num = detail.count_unit_confirm_num;
                          }
                          if (
                            detail.count_unit_add_num ||
                            detail.count_unit_add_num == 0
                          ) {
                            detail.add_num = detail.count_unit_add_num;
                          }
                          if (
                            detail.count_unit_fix_num ||
                            detail.count_unit_fix_num == 0
                          ) {
                            detail.fix_num = detail.count_unit_fix_num;
                          }
                        }

                        return detail;
                      });
                    }
                  } else {
                    this.order = JSON.parse(this.orderBeforPreview);
                    if (
                      response.data.error.code == "ERR670" &&
                      response.data.data &&
                      response.data.data.length
                    ) {
                      this.errorMaterialsList = response.data.data;
                      this.errorMaterialInfoMessage = response.data.error.msg;
                      this.errorMaterialInfoAlert = true;
                    } else if (
                      response.data.error.code == "ERR488" &&
                      response.data.data &&
                      response.data.data.length
                    ) {
                      this.overSellMaterials = response.data.data;
                      this.overSellErrorFlg = true;
                    } else if (
                      response.data.error.code == "ERR182" &&
                      response.data.data &&
                      Object.keys(response.data.data).length
                    ) {
                      this.showGroupRow = true;

                      if (response.data.data.A) {
                        let materialANumCount = 0;
                        let materialA = response.data.data.A.map((detail) => {
                          return Object.assign({}, detail, {
                            group_id: "A",
                            all_count: (materialANumCount += Number(
                              detail.num
                            )),
                          });
                        });
                        this.errorMaterialsList =
                          this.errorMaterialsList.concat(materialA);
                      }
                      if (response.data.data.B) {
                        let materialBNumCount = 0;
                        let materialB = response.data.data.B.map((detail) => {
                          return Object.assign({}, detail, {
                            group_id: "B",
                            all_count: (materialBNumCount += Number(
                              detail.num
                            )),
                          });
                        });
                        this.errorMaterialsList =
                          this.errorMaterialsList.concat(materialB);
                      }

                      this.errorMaterialInfoMessage = response.data.error.msg;
                      this.errorMaterialInfoAlert = true;
                    }
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$scrollIntoView("order_details_table");
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    async doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      // 检查一下图片上传的error，拒绝上传
      if (this.isNew) {
        if (this.$refs.imgs_file.hasError) {
          this.$store.dispatch("fullscreenLoadingStop");
          return;
        }
        //提交图片集
        var order_img = [];
        if (this.imgs_file && this.imgs_file.length > 0) {
          let response = await Files.imagesUpload(
            this.imgs_file,
            false,
            "images"
          );

          if (response.data.status.isOK()) {
            response.data.data.forEach((img) => order_img.push(img.img_name));
          }
        }

        this.order = Object.assign({}, this.order, { order_img: order_img });
      } else if (!this.isNew) {
        this.submitUploadImg();
      }
      if (this.accountSettings && this.accountSettings.count_unit == 1) {
        this.order.order_details.forEach((detail) => {
          // 开启计数单位后,换算提交
          if (detail.count_unit && detail.count_unit_rate) {
            detail.count_unit_price = detail.price;
            detail.price = detail.count_unit_price / detail.count_unit_rate;
            if (detail.apply_num || detail.apply_num == 0) {
              detail.count_unit_apply_num = detail.apply_num;
              detail.apply_num = detail.apply_num * detail.count_unit_rate;
            }
            if (detail.confirm_num || detail.confirm_num == 0) {
              detail.count_unit_confirm_num = detail.confirm_num;
              detail.confirm_num = detail.confirm_num * detail.count_unit_rate;
            }
            if (detail.add_num || detail.add_num == 0) {
              detail.count_unit_add_num = detail.add_num;
              detail.add_num = detail.add_num * detail.count_unit_rate;
            }
            if (detail.fix_num || detail.fix_num == 0) {
              detail.count_unit_fix_num = detail.fix_num;
              detail.fix_num = detail.fix_num * detail.count_unit_rate;
            }
          }
        });
      }
      this.submitMethod()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/orders");
            } else if (response.data.error.code == "ERR759") {
              //要货单切单失败
              this.preview = false;
              this.mode = "view";
              this.redeliverErrorData = response.data.data;
              this.redeliverErrorDialog = true;
            } else if (
              (response.data.error.code == "ERR670" ||
                response.data.error.code == "ERR182") &&
              response.data.data &&
              (response.data.data.length ||
                Object.keys(response.data.data).length)
            ) {
              this.errorMaterialsList = response.data.data;
              this.errorMaterialInfoMessage = response.data.error.msg;
              this.errorMaterialInfoAlert = true;
            }
            this.$store.dispatch("fullscreenLoadingStop");
            this.$store.commit("refreshToDos", true);
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    addDetail(event) {
      if (event.combineMaterial) {
        this.addCombineOrderDetail(event.combineMaterial, event.num);
      } else {
        this.addOrderDetail(event.material, event.num);
      }
    },
    addCombineOrderDetail(combineMaterial, num) {
      if (num == 0) return;
      var order_combine_material = {
        new: true,
        order_id: this.order.id,
        ruler_id: combineMaterial.id,
        ruler_name: combineMaterial.name,
        price: combineMaterial.price,
        memo: null, // TODO
        combineFlg: true,
        combine_material: combineMaterial,
      };
      // this.makeStockCurrent(order_combine_material);TODO
      if (!isNaN(Number(num))) {
        order_combine_material.apply_num = order_combine_material.fix_num = num;
      }
      this.order_combine_materials.push(order_combine_material);
      this.updateItemSums();
    },
    addOrderDetail(material, num) {
      if (num == 0) return;
      var order_detail = {
        new: true,
        order_id: this.order.id,
        category_name: material.category_name,
        category_code: material.category_code,
        delivery_date_flg: material.delivery_date_flg,
        material_id: material.material_id,
        material_code: material.material_code,
        material_name: material.material_name,
        org_price: material.supply_price ? material.supply_price : 0,
        confirm_price: material.supply_price ? material.supply_price : 0,
        price: material.supply_price
          ? material.count_unit &&
            material.count_unit_rate &&
            this.accountSettings &&
            this.accountSettings.count_unit == 1
            ? material.supply_price * material.count_unit_rate
            : material.supply_price
          : 0, //开启计数单位后价格按比例转换
        auto_flg: 0,
        memo: null,
        rate: material.rate,
        unit: material.unit,
        count_unit: material.count_unit, //开启计数单位后使用计数单位
        count_unit_rate: material.count_unit_rate,
        standard_detail_id: material.standard_detail_id,
        barcode: material.barcode,
        standard_name: material.standard_name,
        error_flg: 0,
        price_flg: 0,
        material: material,
        hide_flg: material.hide_flg,
        campaign: material.campaign,
        add_num_org: material.add_num ? material.add_num : 0,
      };
      this.makeStockCurrent(order_detail);
      if (!isNaN(Number(num))) {
        order_detail.apply_num = order_detail.fix_num = num;
      }
      this.order_details.push(order_detail);
      this.updateItemSums();
    },
    updateItemSums() {
      var priceFix = 0;
      var details_num = 0;
      var apply_num_total = 0;
      var confirm_num_total = 0;
      var weight_total = 0;
      this.orderDetails.forEach((detail) => {
        var apply_num = detail.apply_num ? detail.apply_num : 0;
        var confirm_num = detail.confirm_num ? detail.confirm_num : 0;
        detail.fix_num =  Number(apply_num)
        //件数和总重量总是重新计算
        details_num += detail.fix_num;
        apply_num_total += Number(apply_num);
        confirm_num_total += Number(confirm_num);
        var gross_weight = 0;
        if (!detail.combineFlg) {
          if (detail.standard_detail) {
            gross_weight =
              (Number(detail.standard_detail.gross_weight) *
                Number(
                  detail.standard_detail.gross_weight_config
                    ? detail.standard_detail.gross_weight_config.weight_rate
                    : 1000
                )) /
              1000;
          } else if (detail.material) {
            gross_weight =
              (Number(detail.material.gross_weight) *
                Number(detail.material.gross_weight_rate)) /
              1000;
          }
        } else {
          if (detail.combine_material)
            gross_weight = Number(detail.combine_material.total_weight);
        }
        weight_total += parseFloat(
          Number(detail.fix_num * gross_weight).toFixed(2)
        );
        detail.sum = this.$numberFormatter.moneyFormat(
          parseFloat((detail.price * detail.fix_num).toFixed(4))
        );
        priceFix += parseFloat(detail.sum);
      });
      priceFix = parseFloat(priceFix.toFixed(2)); //解决精度丢失
      this.order.details_num = details_num;
      this.order.apply_num_total = apply_num_total;
      this.order.confirm_num_total = confirm_num_total;

      this.order.weight_total = weight_total;
      if (this.savable) {
        // 非编辑模式整单价格以接口返回为准，不作调整
        this.order.price_fix = this.price_fix = priceFix;
        if (this.order.order_price) {
          this.order.price_cut = this.order.order_price - this.order.price_fix;
        }
      }
    },
    makeStockCurrent(detail) {
      //按要货单位换算当前库存量
      if (
        !detail.rate &&
        detail.standard_detail &&
        detail.standard_detail.rate > 1
      ) {
        detail.rate = detail.standard_detail.rate;
      }
      if (detail.material && detail.rate > 1) {
        detail.current_count_rate = this.$numberFormatter.formatTwoDot(
          detail.material.current_count / detail.rate,
          true
        );
        var current_count_rate_int = parseInt(
          detail.material.current_count / detail.rate
        );
        if (detail.material.current_count % detail.rate) {
          var current_count_rate_float =
            detail.material.current_count % detail.rate;
          detail.current_count_rate_with_unit = i18n.t(
            "Order.DetailFields.quantityWithMultipleUnits",
            [
              current_count_rate_int,
              detail.unit,
              current_count_rate_float,
              detail.material.default_unit,
            ]
          );
        } else {
          detail.current_count_rate_with_unit = i18n.t(
            "Order.DetailFields.quantityWithUnit",
            [current_count_rate_int, detail.unit]
          );
        }
      }
    },
    async submitUploadInvoiceImg() {
      this.$store.dispatch("fullscreenLoading");
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.invoice_img_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      //先尝试通过第三方接口提交图片
      Orders.thirdAPIUploadInvoiceImg(
        this.invoice_img_file,
        "orders",
        this.thirdAccessToken
      )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              var image_url = response.data.data.img_url;
              var image = response.data.data.img;
              //通过第三方的接口提交保存
              Orders.thirdAPISaveInvoiceImg(
                {
                  // account_id: this.accountID,
                  order_code: this.order.order_code,
                  fapiao_img: image,
                },
                this.thirdAccessToken
              )
                .then()
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
              //通过自己的接口提交保存
              Orders.update({
                order_code: this.order.order_code,
                invoice_url: image_url,
              })
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.UploadDialog = false;
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
              //获取最新数据
              this.getOrderFromAPI();
              this.$snackbar.success(
                i18n.t("Order.messages.uploadInvoiceSuccess")
              );
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    async submitUploadImg() {
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }

      //提交图片集
      var order_img = [];
      if (this.imgs_file && this.imgs_file.length > 0) {
        let response = await Files.imagesUpload(
          this.imgs_file,
          false,
          "images"
        );

        if (response.data.status.isOK()) {
          response.data.data.forEach((img) => order_img.push(img.img_name));
          Orders.update({
            order_code: this.order.order_code,
            order_img: order_img,
          })
            .then(
              function () {
                // if (response.data.status.isOK()) {
                //   this.UploadDialog = false;
                // }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            )
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
          //获取最新数据
          // this.getOrderFromAPI();
          // this.$snackbar.success(i18n.t("Order.messages.uploadInvoiceSuccess"));
        }
      }
    },
    saveExpress() {
      Orders.saveExpress({
        id: this.order.id,
        express_price: this.order.express_price,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.edit_express = false;
            this.getOrderFromAPI();
          }
        }.bind(this)
      );
    },
    removeFromImages(i) {
      this.album.splice(i, 1);
      this.imgs_file.splice(i, 1);
    },
   async resetOrder() {
     this.shop = {
       id: this.userType == 0 ? this.accountUser.id : this.accountUser.shop_id
     };
     var today = new Date();

     today.setHours(0, 0, 0, 0);
     let response = await Shops.getShopAddress({includeShop: 1});


     let address = [];
     if (response.data.status.isOK() && response.data.shop_address) {
       response.data.shop_address.forEach((shopAddress) => {
         if (shopAddress.shopAddress_flg) {
           address = shopAddress
         }
       });
     }

     this.order = {
       shop_id: this.userType == 0 ? this.accountUser.id : this.accountUser.shop_id,
       status: 1,
       origin_flg: "002",
       created_id: this.accountUser.id,
       creater_name: this.accountUser.name,
       actual_date: this.$datetimeUtils.formatTime(new Date()),
       expect_date: this.$datetimeUtils.formatTime(this.$datetimeUtils.addDays(today, this.accountSettings && this.accountSettings.distribution_default_receive_date ? this.accountSettings.distribution_default_receive_date : 1)),
       order_details: [],
       order_combine_materials: [],
       address: address
     };
   }
  },

  watch: {
    $route(to, from) {
      this.selectShopAddressDialog = false;
      if (to.path.startsWith("/order-new")) {
        this.mode = "new";
        // 重新初始化界面
        this.panels = [0];
        this.tab = null;
        this.serverErrors = [];
        this.selectShopAddress = null;
        this.shop = {};
        this.order = {};
        this.bill = {};
        this.addMaterial = null;
        this.order_details = [];
        this.order_combine_materials = [];
        this.new_order_details = [];
        this.order_activities = [];
        this.order_relations = [];
        this.filter = "";
      } else if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/orders/" + to.params.id);
      } else if (from.path.startsWith("/order-new") && from.path != to.path) {
        this.mode = "view"; // 从order-new退回时触发状态变化和数据重加载
      }
    },
    accountUser: {
      immediate:true,
      handler() {
        if (this.isNew && this.accountUser) {
          this.resetOrder()
        }
      }
    },
    mode: {
      handler() {
        if (this.isNew && this.accountUser) {
          this.resetOrder()
        } else {
          if (this.$route.params.id) {
            this.getOrderFromAPI();
          }
        }
      },
    },
    // settings: {
    //   immediate: true,
    //   handler() {
    //     if (this.settings && this.settings.push_platform == 1017) {
    //       Settings.getThirdApiAccessToken().then(
    //         function (response) {
    //           if (response.data.status.isOK()) {
    //             this.thirdAccessToken = response.data.access_token;
    //           }
    //         }.bind(this)
    //       );
    //     }
    //     if (
    //       !this.$route.path.startsWith("/order-new") &&
    //       this.settings &&
    //       this.settings.count_unit == 1
    //     ) {
    //       this.getOrderFromAPI();
    //     }
    //   },
    // },
    edit_details_mode_enable: {
      handler() {
        if (!this.edit_details_mode_enable) {
          this.edit_details_mode = 0;
        }
      },
    },
    edit_details_mode: {
      handler() {
        localStorage.setItem("order_new_details_mode", this.edit_details_mode);
        if (this.edit_details_mode == 1) {
          this.loaded = true;
        } else {
          this.loaded = false;
        }
      },
    },
    // mainContentScrolled: {// 向上滚动收起表头
    //   handler() {
    //     if (this.mainContentScrolled > 100) this.panels = [];
    //     else if (
    //       this.fixHeaderHeightInPx > 150 &&
    //       this.mainContentScrolled == 0
    //     )
    //       this.panels = [0];
    //   },
    // },
    // panels: {
    //   handler() {
    //     this.$setIntervalMainResizer();
    //   },
    // },
    order: {
      handler() {
        this.order_details =
          this.order && this.order.order_details
            ? this.order.order_details
            : [];
        this.order_combine_materials =
          this.order && this.order.order_combine_materials
            ? this.order.order_combine_materials
            : [];
        this.shop = this.order && this.order.shop ? this.order.shop : this.shop;
        this.bill = this.order && this.order.bill ? this.order.bill : this.bill;
        this.price_fix = this.order ? this.order.price_fix : 0;
        this.updateItemSums(); //重新计算件数和总重量，编辑模式下重新计算this.price_fix，因为后台给的price_fix是去掉所有单品和整单优惠的，不准确
      },
    },
    // order_details: {
    //   deep: true,
    //   handler() {
    // var priceFix = 0;
    // this.order_details.forEach((detail) => {
    //   var apply_num = detail.apply_num ? detail.apply_num : 0;
    //   var confirm_num = detail.confirm_num ? detail.confirm_num : 0;
    //   var add_num = detail.add_num ? detail.add_num : 0;
    //   if (this.savable) {
    //     detail.fix_num = this.isNew // 新建时取申请量，其他时候取确认量加追加量
    //       ? Number(apply_num)
    //       : Number(confirm_num) + Number(add_num); //兼容添加新商品、确认商品数量、编辑追加商品数量的累计申请量计算
    //   } // 非编辑模式以接口返回为准，不作调整
    //   detail.sum = detail.price * detail.fix_num;
    //   priceFix += detail.sum;
    //   //按要货单位换算当前库存量
    //   if (
    //     !detail.rate &&
    //     detail.standard_detail &&
    //     detail.standard_detail.rate > 1
    //   ) {
    //     detail.rate = detail.standard_detail.rate;
    //   }
    //   if (detail.material && detail.rate > 1) {
    //     detail.current_count_rate = this.$numberFormatter.formatTwoDot(
    //       detail.material.current_count / detail.rate
    //     );
    //     var current_count_rate_int = parseInt(
    //       detail.material.current_count / detail.rate
    //     );
    //     if (detail.material.current_count % detail.rate) {
    //       var current_count_rate_float =
    //         detail.material.current_count % detail.rate;
    //       detail.current_count_rate_with_unit = i18n.t(
    //         "Order.DetailFields.quantityWithMultipleUnits",
    //         [
    //           current_count_rate_int,
    //           detail.unit,
    //           current_count_rate_float,
    //           detail.material.default_unit,
    //         ]
    //       );
    //     } else {
    //       detail.current_count_rate_with_unit = i18n.t(
    //         "Order.DetailFields.quantityWithUnit",
    //         [current_count_rate_int, detail.unit]
    //       );
    //     }
    //   }
    // });
    // this.order.price_fix = this.price_fix = priceFix;
    // this.order.price_cut = this.order.order_price - this.order.price_fix;
    //   },
    // },
    shop: {
      handler() {
        if (this.isView && this.shop && this.shop.id)
          MaterialTemplates.fetchByShop(this.shop.id, {hide_flgs: [0]}).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.materials = response.data.template_details;
              }
            }.bind(this)
          );
      },
    },
    addMaterial: {
      handler() {
        if (this.addMaterial) {
          if (this.addMaterial.combineFlg && this.addMaterial.id) {
            this.addCombineOrderDetail(this.addMaterial);
            this.addMaterial = {
              material_id: 0,
              material_code: "",
              material_name: "",
              ruler_name: "",
              standard_name: "",
            }; //消除显示
          } else if (
            !this.addMaterial.combineFlg &&
            this.addMaterial.material_id
          ) {
            this.addOrderDetail(this.addMaterial);
            this.addMaterial = {
              material_id: 0,
              material_code: "",
              material_name: "",
              ruler_name: "",
              standard_name: "",
            }; //消除显示
          }
        }
      },
    },
    detail_memo_item: {
      handler() {
        if (this.detail_memo_item) {
          if (this.savable && this.detail_memo_item.delivery_date_flg) {
            if (
              this.detail_memo_item.memo &&
              this.detail_memo_item.memo.length >= 10
            ) {
              this.memo_dialog_expect_date = this.detail_memo_item.memo
                .substring(0, 10)
                .replace("-", "/");
              this.memo_dialog_memo = this.detail_memo_item.memo.substring(11);
            } else {
              var today = new Date();
              today.setHours(0, 0, 0, 0);
              this.memo_dialog_expect_date = this.$datetimeUtils.formatDate(
                this.$datetimeUtils.addDays(
                  today,
                  this.accountSettings &&
                    this.accountSettings.distribution_default_receive_date
                    ? this.accountSettings.distribution_default_receive_date
                    : 1
                )
              );
              this.memo_dialog_memo = this.detail_memo_item.memo
                ? this.detail_memo_item.memo
                : "";
            }
          } else {
            this.memo_dialog_memo = this.detail_memo_item.memo
              ? this.detail_memo_item.memo
              : "";
          }
        }
      },
    },
    memo_dialog_expect_date: {
      handler() {
        this.detail_memo_item.memo = this.memo_dialog_expect_date
          ? this.memo_dialog_expect_date + " " + this.memo_dialog_memo
          : this.memo_dialog_memo;
      },
    },
    memo_dialog_memo: {
      handler() {
        this.detail_memo_item.memo = this.memo_dialog_expect_date
          ? this.memo_dialog_expect_date + " " + this.memo_dialog_memo
          : this.memo_dialog_memo;
      },
    },
    UploadDialog: {
      handler() {
        if (!this.UploadDialog && this.invoice_img_file) {
          this.invoice_img_file = null;
        }
      },
    },
    invoice_img: {
      handler() {
        if (!this.invoice_img) {
          this.invoice_img_file = null;
        }
      },
    },
    invoice_img_file: {
      handler() {
        if (this.invoice_img_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.invoice_img_file);
          let that = this;
          reader.onload = function () {
            that.invoice_img = this.result;
          };
        }
      },
    },
    errorMaterialInfoAlert: {
      deep: true,
      handler() {
        if (!this.errorMaterialInfoAlert) {
          this.errorMaterialInfoMessage = "";
          this.errorMaterialsList = [];
          this.showGroupRow = false;
        }
      },
    },
    edit_express: {
      deep: true,
      handler() {
        if (this.edit_express && !this.order.edit_express_flg) {
          this.order.edit_express_flg = 1;
        }
      },
    },
    imgs_file: {
      deep: true,
      handler() {
        if (this.imgs_file.length) {
          if (this.imgs_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.album = [];
            this.imgs_file = [];
          } else {
            this.album = [];
            this.imgs_file.forEach((img) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.push(this.result);
              };
            });
          }
        } else {
          this.album = this.order.order_img ? this.order.order_img : [];
        }
      },
    },
    selectShopAddress: {
      handler() {
        if (this.selectShopAddress) {
          let order_extra = {
            express: {
              receiver_name: this.selectShopAddress.name,
              receiver_phone: this.selectShopAddress.phone,
              receiver_province: this.selectShopAddress.province_name,
              receiver_city: this.selectShopAddress.city_name,
              receiver_area: this.selectShopAddress.area_name,
              receiver_address: this.selectShopAddress.address
            }
          }
          if (this.selectShopAddress && this.selectShopAddress.shopAddress_flg) {
            this.order.order_extra = null;
          } else {
            this.order.order_extra = order_extra;
          }
          if (this.order.id) { //存在要货订单时，直接更新数据
            Orders.updateOrdersExtras(this.order.id, this.selectShopAddress).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$snackbar.success(i18n.t("Order.messages.orderExtrasSuccess"));
                }
              }.bind(this)
            )
          }
          this.selectShopAddress = null;
        }
      }
    },
  },
};
</script>
